import React, { useState, useContext } from "react";
import { Offcanvas, Dropdown } from "react-bootstrap";
import UserContext from "../../../contexts/UserContext";
import styled from "styled-components";
import logo from "../../../images/atendflow-logo.png";
import logo_symbol from "../../../images/atendflow-icon.png";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Logout } from "../../../services/LoginServices";
import { Hash } from "../../../helpers/Helpers";
import {
  IconMenu2,
  IconUser,
  IconUsers,
  IconMessageCircle2,
  IconCalendar,
  IconFileText,
  IconShare,
  IconBrain,
  IconSettings,
  IconBrandWhatsapp,
  IconBriefcase,
  IconLogout,
  IconChevronDown,
  IconChevronRight,
  IconChecklist,
} from "@tabler/icons-react";

const MobileHeader = () => {
  const { bottyData, user } = useContext(UserContext);
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);
  const handleDropdownClose = () => setShowDropdown(false);
  const handleDropdownToggle = (isOpen) => setShowDropdown(isOpen);

  // Estado para controlar seções expandidas
  const [expandedSections, setExpandedSections] = useState({
    comunicacao: true,
    gerenciamento: false,
    inteligencia: false,
    configuracoes: false,
  });

  const superuser = {
    1: "Admin",
    2: "Manager",
    3: "Staff",
  };

  const handleClose = () => setShowMenu(false);
  const handleShow = () => setShowMenu(true);

  const handleClick = (path) => {
    navigate(path);
    handleClose();
  };

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const currentPath = location.pathname;

  // Verifica se uma seção está ativa
  const isSectionActive = (section) => {
    switch (section) {
      case "comunicacao":
        return (
          currentPath.includes("/chat") ||
          currentPath.includes("/crm") ||
          currentPath.includes("/campaigns")
        );
      case "gerenciamento":
        return (
          currentPath.includes("/calendar") ||
          currentPath.includes("/templates") ||
          currentPath.includes("/automations")
        );
      case "inteligencia":
        return currentPath.includes("/agents");
      case "configuracoes":
        return (
          currentPath.includes("/whatsapp") ||
          currentPath.includes("/business-settings")
        );
      default:
        return false;
    }
  };

  return (
    <>
      <MobileHeaderContainer>
        <HamburgerButton onClick={handleShow}>
          <IconMenu2 size={24} />
        </HamburgerButton>

        <LogoContainer>
          <HeaderLogo src={logo} alt="logo" />
        </LogoContainer>

        <Dropdown
          className="nav-item dropdown header-profile"
          as="li"
          show={showDropdown}
          onToggle={handleDropdownToggle}
        >
          <Dropdown.Toggle as="a" variant="" className="nav-link">
            <img
              src={
                user?.user_photo
                  ? Hash("75x75", user?.user_photo.replaceAll('"', ""))
                  : require("../../../images/user.png")
              }
              width={35}
              height={35}
              alt="profile"
            />
            <div className="header-info d-none d-sm-block">
              <span>{user?.first_name || ""}</span>
              <p>{superuser[user?.superuser_level] || ""}</p>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu align="right" className="mt-2">
            <Link
              to={`/user-details/${user?.user_id || ""}`}
              className="dropdown-item ai-icon"
              onClick={handleDropdownClose}
            >
              <IconUser size={18} className="text-primary" />
              <span className="ml-2">Perfil</span>
            </Link>

            <Link to="#" onClick={Logout} className="dropdown-item ai-icon">
              <IconLogout size={18} className="text-danger" />
              <span className="ml-2">Sair</span>
            </Link>
          </Dropdown.Menu>
        </Dropdown>
      </MobileHeaderContainer>

      <StyledOffcanvas
        show={showMenu}
        onHide={handleClose}
        placement="start"
        style={{ maxWidth: 300 }}
      >
        <Offcanvas.Header closeButton>
          <MenuLogo src={logo} alt="logo" />
        </Offcanvas.Header>

        <Offcanvas.Body>
          {!user.is_superuser ? (
            <MenuSection>
              <SubMenuItem
                active={currentPath.includes("/calendar")}
                onClick={() => handleClick("/calendar")}
              >
                <i className="las la-calendar" />
                <span>Agenda</span>
              </SubMenuItem>
            </MenuSection>
          ) : (
            <>
              {/* Seção de Comunicação */}
              <MenuSection>
                <MenuSectionHeader
                  active={isSectionActive("comunicacao")}
                  onClick={() => toggleSection("comunicacao")}
                >
                  <div className="d-flex">
                    <div className="section-icon">
                      <IconMessageCircle2 size={20} />
                    </div>
                    <div className="section-title">
                      <span>Comunicação</span>
                    </div>
                  </div>
                  {expandedSections.comunicacao ? (
                    <IconChevronDown size={18} className="toggle-icon" />
                  ) : (
                    <IconChevronRight size={18} className="toggle-icon" />
                  )}
                </MenuSectionHeader>

                {expandedSections.comunicacao && (
                  <SubMenuContainer>
                    {bottyData?.uid && (
                      <SubMenuItem
                        active={currentPath.includes("/chat")}
                        onClick={() => handleClick("/chat")}
                      >
                        <IconBrandWhatsapp size={20} />
                        <span>Whatsapp</span>
                      </SubMenuItem>
                    )}
                    <SubMenuItem
                      active={currentPath.includes("/crm")}
                      onClick={() => handleClick("/crm")}
                    >
                      <IconUsers size={20} />
                      <span>CRM</span>
                    </SubMenuItem>
                  </SubMenuContainer>
                )}
              </MenuSection>

              {/* Seção de Gerenciamento */}
              <MenuSection>
                <MenuSectionHeader
                  active={isSectionActive("gerenciamento")}
                  onClick={() => toggleSection("gerenciamento")}
                >
                  <div className="d-flex">
                    <div className="section-icon">
                      <IconChecklist size={20} />
                    </div>
                    <div className="section-title">
                      <span>Gestão</span>
                    </div>
                  </div>
                  {expandedSections.gerenciamento ? (
                    <IconChevronDown size={18} className="toggle-icon" />
                  ) : (
                    <IconChevronRight size={18} className="toggle-icon" />
                  )}
                </MenuSectionHeader>

                {expandedSections.gerenciamento && (
                  <SubMenuContainer>
                    <SubMenuItem
                      active={currentPath.includes("/calendar")}
                      onClick={() => handleClick("/calendar")}
                    >
                      <IconCalendar size={20} />
                      <span>Agenda</span>
                    </SubMenuItem>
                    {bottyData?.uid && (
                      <>
                        <SubMenuItem
                          active={currentPath.includes("/templates")}
                          onClick={() => handleClick("/templates")}
                        >
                          <IconFileText size={20} />
                          <span>Templates</span>
                        </SubMenuItem>

                        <SubMenuItem
                          active={currentPath.includes("/automations")}
                          onClick={() => handleClick("/automations")}
                        >
                          <IconShare size={20} />
                          <span>Automações</span>
                        </SubMenuItem>
                      </>
                    )}
                  </SubMenuContainer>
                )}
              </MenuSection>

              {/* Seção de Inteligência */}
              <MenuSection>
                <MenuSectionHeader
                  active={isSectionActive("inteligencia")}
                  onClick={() => toggleSection("inteligencia")}
                >
                  <div className="d-flex">
                    <div className="section-icon">
                      <IconBrain size={20} />
                    </div>
                    <div className="section-title">
                      <span>Inteligência</span>
                    </div>
                  </div>
                  {expandedSections.inteligencia ? (
                    <IconChevronDown size={18} className="toggle-icon" />
                  ) : (
                    <IconChevronRight size={18} className="toggle-icon" />
                  )}
                </MenuSectionHeader>

                {expandedSections.inteligencia && (
                  <SubMenuContainer>
                    <SubMenuItem
                      active={currentPath.includes("/agents")}
                      onClick={() => handleClick("/agents")}
                    >
                      <IconBrain size={20} />
                      <span>Agentes</span>
                    </SubMenuItem>
                  </SubMenuContainer>
                )}
              </MenuSection>

              {/* Configurações */}
              <MenuSection>
                <MenuSectionHeader
                  active={isSectionActive("configuracoes")}
                  onClick={() => toggleSection("configuracoes")}
                >
                  <div className="d-flex">
                    <div className="section-icon">
                      <IconSettings size={20} />
                    </div>
                    <div className="section-title">
                      <span>Configurações</span>
                    </div>
                  </div>
                  {expandedSections.configuracoes ? (
                    <IconChevronDown size={18} className="toggle-icon" />
                  ) : (
                    <IconChevronRight size={18} className="toggle-icon" />
                  )}
                </MenuSectionHeader>

                {expandedSections.configuracoes && (
                  <SubMenuContainer>
                    <SubMenuItem
                      active={currentPath === "/whatsapp"}
                      onClick={() => handleClick("/whatsapp")}
                    >
                      <IconBrandWhatsapp size={20} />
                      <span>Whatsapp</span>
                    </SubMenuItem>
                    <SubMenuItem
                      active={currentPath === "/business-settings"}
                      onClick={() => handleClick("/business-settings")}
                    >
                      <IconBriefcase size={20} />
                      <span>Meu negócio</span>
                    </SubMenuItem>
                  </SubMenuContainer>
                )}
              </MenuSection>
            </>
          )}
        </Offcanvas.Body>
      </StyledOffcanvas>
    </>
  );
};

// Header móvel principal
const MobileHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  color: #1e293b;
  padding: 10px 20px;
  height: 60px;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1001;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;

  .dropdown-toggle:after {
    display: none !important;
  }
`;

// Botão hamburguer
const HamburgerButton = styled.button`
  background: none;
  border: none;
  color: #1e293b;
  font-size: 24px;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f8f9fa;
  }

  &:focus {
    outline: none;
  }
`;

// Logo container
const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
`;

// Logo no header
const HeaderLogo = styled.img`
  height: 27px;
`;

// Container do Offcanvas customizado
const StyledOffcanvas = styled(Offcanvas)`
  .offcanvas-header {
    background-color: #fff;
    padding: 15px 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    .btn-close {
      position: absolute;
      right: 15px;
    }
  }

  .offcanvas-body {
    background-color: #fff;
    padding: 0;
  }
`;

// Logo dentro do menu
const MenuLogo = styled.img`
  width: 150px;
`;

// Seção do menu
const MenuSection = styled.div`
  margin: 20px 0;
`;

// Cabeçalho da seção do menu (móvel)
const MenuSectionHeader = styled.div`
  padding: 7.5px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #1e293b;
  background-color: ${(props) =>
    props.active ? "var(--primary)" : "rgba(255, 255, 255, 0.05)"};
  width: 90%;
  margin: auto;
  border-radius: 20px;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--primary);
    color: #fff;
  }

  .section-title {
    display: flex;
    align-items: center;
    margin-left: 10px;
    color: ${(props) => (props.active ? "#fff" : "inherit")};

    span {
      margin-left: 10px;
    }
  }

  .section-icon {
    color: ${(props) => (props.active ? "#fff" : "inherit")};
  }

  &:hover .section-icon {
    color: #fff;
  }

  .toggle-icon {
    color: ${(props) => (props.active ? "#fff" : "var(--primary)")};
  }

  &:hover .toggle-icon {
    color: #fff;
  }
`;

// Container para submenus
const SubMenuContainer = styled.div`
  transition: max-height 0.3s ease-in-out;
  overflow: hidden;
`;

// Item do submenu
const SubMenuItem = styled.div`
  padding: 7.5px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.active ? "var(--primary)" : "transparent"};
  color: ${(props) => (props.active ? "#fff" : "#1e293b")};
  width: 85%;
  margin: 10px auto;
  border-radius: 20px;
  padding-left: 35px;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--primary);
    color: #fff;
  }

  svg {
    min-width: 20px;
    text-align: left;
    color: ${(props) => (props.active ? "#fff" : "inherit")};
  }

  &:hover svg {
    color: #fff;
  }

  span {
    margin-left: 10px;
    white-space: nowrap;
  }
`;

export default MobileHeader;
